module.exports = __webpack_public_path__ + "static/media/schilling center.ef5f8b00.jpeg";